import { createContext, useContext, useEffect, useState, useMemo } from 'react';

/**
 * Shared page-title state so AppShell can render ONE full-width gradient
 * banner (title + subtitle) at the top of every page, matching
 * eventimage.logisticalagility.com's header — instead of each page owning
 * its own flat white header bar. Pages call usePageHeader(title, subtitle)
 * once; AppShell reads it via usePageHeaderValue().
 */
const PageHeaderContext = createContext(null);

export function PageHeaderProvider({ children }) {
  const [header, setHeader] = useState({ title: '', subtitle: '' });
  const value = useMemo(() => ({ header, setHeader }), [header]);
  return <PageHeaderContext.Provider value={value}>{children}</PageHeaderContext.Provider>;
}

/** Call from a page component to set the banner's title/subtitle. */
export function usePageHeader(title, subtitle) {
  const ctx = useContext(PageHeaderContext);
  useEffect(() => {
    ctx?.setHeader({ title, subtitle });
  }, [title, subtitle]); // eslint-disable-line
}

/** Consumed by AppShell to render the banner. */
export function usePageHeaderValue() {
  const ctx = useContext(PageHeaderContext);
  return ctx?.header ?? { title: '', subtitle: '' };
}
